import { useEffect, useState } from 'react';
const getHash = (): string | undefined => typeof window !== 'undefined' ? decodeURIComponent(window.location.hash.replace('#', '')) : undefined;
export const useHash = (): string | undefined | null => {
  const [hash, setHash] = useState(getHash());
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
    const handleHashChange = () => {
      setHash(getHash());
    };
    if (isClient) {
      window.addEventListener('hashchange', handleHashChange);
      return () => {
        window.removeEventListener('hashchange', handleHashChange);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return isClient ? hash : null;
};